import styled from 'styled-components';

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 8px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
`;

export const QuestionPrefix = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.75px;
  font-weight: 400;
  color: #4c4c4c;
`;

export const FeatureName = styled.p`
  margin: 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: #202020;
`;

export const StarsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
  color: #202020;
  margin-left: 16px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
`;
